import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { styled } from "@mui/material/styles"

export const StyledDiv = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  "& svg": {
    color: theme.palette.primary.dark
  }
}))

export const StyledFontAwesomeIcon = styled(FontAwesomeIcon)({
  color: "rgba(0, 0, 0, 0.54);",
  fontSize: "1.5rem",
  marginRight: 5
})

export const StyledUpdateIcon = styled(FontAwesomeIcon)({
  cursor: "pointer"
})
